import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleDprSignature = {
  namespaced: true,

  state: {
    name: 'dpr-signature',
    dprSignatures:[]
  },

  mutations,
  getters,
  actions
}

export default moduleDprSignature;